import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';


export const selectSession = (state: IRootMachineSnapshot) => {
  return state.context.session;
};
